import React from 'react'
import ReactDOM from 'react-dom'

const Location = ({ location, handleSetCurrentTown }) => {
    return <div
        data-id={ location.ID }
        data-name={ location.CITY }
        className="happy-select-location__item"
        onClick={ handleSetCurrentTown.bind(this, location.ID, location.CITY) }
    >
        { location.CITY }
    </div>
}

export default Location